// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arenaContainer {
    max-width: 1024px;
    margin: auto;
}

.arenas {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/onGoingArena/OnGoingArena.style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;AACf","sourcesContent":[".arenaContainer {\n    max-width: 1024px;\n    margin: auto;\n}\n\n.arenas {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
